import { render } from "./TheEducation.vue?vue&type=template&id=c589f402"
import script from "./TheEducation.vue?vue&type=script&lang=js"
export * from "./TheEducation.vue?vue&type=script&lang=js"

import exportComponent from "/home/cyrill/Projects/kmapper/repos/cyrill.codeberg.page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__